/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { NotificationTitle } from '../../models/notification-title';
import { UserAlertNotificationSetting } from '../../models/user-alert-notification-setting';

export interface GetSettingsByTitleRoleId_2$Params {
  title: NotificationTitle;
  userId: number;
}

export function getSettingsByTitleRoleId_2(http: HttpClient, rootUrl: string, params: GetSettingsByTitleRoleId_2$Params, context?: HttpContext): Observable<StrictHttpResponse<UserAlertNotificationSetting>> {
  const rb = new RequestBuilder(rootUrl, getSettingsByTitleRoleId_2.PATH, 'get');
  if (params) {
    rb.path('title', params.title, {});
    rb.path('userId', params.userId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<UserAlertNotificationSetting>;
    })
  );
}

getSettingsByTitleRoleId_2.PATH = '/api/user/notification/alert/setting/title/{title}/userId/{userId}';
